module.exports = __webpack_public_path__ + "static/media/Dog_Phone_Logo.c3d2e07e.png";